import React from 'react';
import { MobilityInstructionsType } from 'modules/selfServices/types/SelfService';
import useLabelTranslation from 'hooks/useLabelTranslation';
import { Carousel } from 'components/ui';
import { AbstractMedia, MediaType } from 'types/AbstractMedia';

type MobilityInstructionsProps = {
  mobilityInstructions: MobilityInstructionsType
};

const MobilityInstructionsSection: React.FC<MobilityInstructionsProps> = ({ mobilityInstructions }) => {
  const { medias = [], message } = mobilityInstructions;
  const { getLabelTranslation } = useLabelTranslation();

  const videos = React.useMemo(
    () => medias.filter((media) => media.type === MediaType.VIDEO),
    [medias],
  );

  const [videoIndexPreview, setVideoIndexPreview] = React.useState<number>();

  const handleOpenVideoPreview = React.useCallback(
    (media: AbstractMedia) => setVideoIndexPreview(
      media.type === MediaType.VIDEO ? videos.findIndex((video) => video.id === media.id) : undefined,
    ),
    [videos],
  );

  const handleCloseVideoPreview = React.useCallback(() => setVideoIndexPreview(undefined), []);

  return (
    <>
      <div className="h-px w-full bg-border-default mb-l" />
      {message && <div className="text-center text-default">{getLabelTranslation(message)}</div>}
      {medias.length > 0 && (
        <Carousel
          hideCursor
          hideActions
          medias={medias}
          onMediaClick={handleOpenVideoPreview}
          carouselClassName="mt-0!"
          className="rounded-xl carousel-card"
        />
      )}
      {videoIndexPreview >= 0 && (
        <Carousel
          fullscreen
          medias={videos}
          carouselClassName="carousel-card"
          onClose={handleCloseVideoPreview}
          defaultMediaIndex={videoIndexPreview}
        />
      )}
    </>
  );
};

export default MobilityInstructionsSection;
